module.exports = __webpack_public_path__ + "static/media/img-4a4ff174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/png/my_location_icon.png
// module id = 5265
// module chunks = 39